//import { Plugins } from "@capacitor/core";
import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';
import { Device } from '@capacitor/device';
import { Dialog } from '@capacitor/dialog';
import { Storage } from '@capacitor/storage';
import { SplashScreen } from '@capacitor/splash-screen';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { Toast } from '@capacitor/toast';
import event_bus from '../../main';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import firebase_config from '../../../firebase_config';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import { Share } from '@capacitor/share';

export default {
	addPhoneBackButtonListerner() {
		App.addListener('backButton', (data) => {
			event_bus.$router.back();
		});
	},

	async getCurrentPosition(options) {
		const coordinates = await Geolocation.getCurrentPosition();
		if (coordinates) {
			return coordinates;
		}
	},

	async checkLocationPermissions() {
		const permissions = await Geolocation.checkPermissions();
		if (permissions) {
			return permissions;
		}
	},

	async requestLocationPermissions() {
		const request = await Geolocation.requestPermissions();
		if (request) {
			return request;
		}
	},

	async deviceShare(options) {
		await Share.share(options);
	},

	async showAlert(options) {
		await Dialog.alert(options);
	},

	async showPrompt(options) {
		return await Dialog.prompt(options);
	},
	async showConfirm(options) {
		return await Dialog.confirm(options);
	},

	async showToast(options) {
		await Toast.show(options);
	},

	async openUrl(url_to_open) {
		await Browser.open({ url: url_to_open, toolbarColor: '#e60000' });
	},

	async getPhotoToUpload() {
		return await Camera.getPhoto({
			quality: 80,
			allowEditing: false,
			resultType: CameraResultType.Base64,
			source: CameraSource.Prompt,
			width: 450,
			height: 450,
		});
	},

	async getPhoneIdForReport() {
		const user_id = await Device.getInfo();
		return user_id;
	},

	async getPhoneId() {
		const user_id = await Device.getId();
		return user_id;
	},

	async getObject(key_name) {
		const ret = await Storage.get({ key: key_name });
		return JSON.parse(ret.value);
	},

	async setItem(key_name, key_value) {
		await Storage.set({
			key: key_name,
			value: key_value,
		});
	},

	async getItem(key_name) {
		const value = await Storage.get({ key: key_name });
		return value;
	},

	async removeItem(key_name) {
		await Storage.remove({ key: key_name });
	},

	openAppSettings() {
		NativeSettings.open({
			optionAndroid: AndroidSettings.ApplicationDetails,
			optionIOS: IOSSettings.App,
		});
	},

	hideSplashScreen() {
		SplashScreen.hide();
	},
	initializeFirebase() {
		//console.log(FirebaseAnalytics)
		//console.log(firebase_config)
		FirebaseAnalytics.initializeFirebase(firebase_config);
	},
	Capacitor,
	FirebaseAnalytics,
};
